import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {TenantService} from './tenant.service';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Observable, of} from 'rxjs';
import firebase from 'firebase/compat/app';
import {map} from 'rxjs/operators';


@Injectable({
  providedIn: "root"
})
export class PaypalService {

  constructor(
    private http:HttpClient,
    private tenant:TenantService,
    private afs: AngularFirestore) {

  }

  confirmCoursePurchase(courseId:string, paypalOrderId:string, purchaseSessionId:string) {
    return this.http.post<any>(
      environment.api.confirmPaypalPurchaseUrl,
      {
        courseId,
        paypalOrderId,
        purchaseSessionId,
        tenantId: this.tenant.id,
      });
  }

  confirmBundlePurchase(bundleCode:string, paypalOrderId:string, purchaseSessionId:string) {
    return this.http.post<any>(
      environment.api.confirmPaypalPurchaseUrl,
      {
        bundleCode,
        paypalOrderId,
        purchaseSessionId,
        tenantId: this.tenant.id,
      });
  }

  initPaypalPurchaseCourseSession(userId: string, courseId: string, couponId:string, price:number): Observable<any> {
    return this.createPurchaseSession({
      userId,
      courseId,
      couponId,
      price,
      type: 'paypal'
    });

  }

  initPaypalPurchaseBundleSession(userId: string, bundleId:string, price:number): Observable<any> {
    return this.createPurchaseSession({
      userId,
      bundleId,
      price,
      type: 'paypal'
    });

  }

  private createPurchaseSession(sessionParams): Observable<any> {
    const purchaseSessionId = this.afs.createId();

    const purchaseSessionPath = `schools/${this.tenant.id}/purchaseSessions/${purchaseSessionId}`;

    const session = {
      ...sessionParams,
      status: 'ongoing',
      createdAt: firebase.firestore.Timestamp.now()
    };

    return of(this.afs.firestore.doc(purchaseSessionPath).set(session))
      .pipe(
        map(() => {
          return {
            id: purchaseSessionId,
            ...session,
          };
        })
      );


  }


}
